import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Header from './Header';
import MainPage from './MainPage';
import Overview from './Overview';
import Publications from './Publications';
import Footer from './Footer';
import Contact from './Contact';
import News from './News';
import ReimaginingDance from './ReimaginingDance';
import BalancingIndeterminacy from './BalancingIndeterminacy';
import LyricJamSonic from './LyricJamSonic';
import LyricJam from './LyricJam';
import ActivationSteering from './ActivationSteering';
import LyotardSublime from './LyotardSublime';

function App() {
  return (
    <div className="app-container">
      <Router>
      <CssBaseline />
      <Header />
      <Container maxWidth="lg" className="content-container">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/news" element={<News />} />
          <Route path="/NLP_lab" element={<Overview />} />
          <Route path="/NLP_lab.html" element={<Overview />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reimagining-dance" element={<ReimaginingDance />} />
          <Route path="/balancing-indeterminacy" element={<BalancingIndeterminacy />} />
          <Route path="/lyricjam-sonic" element={<LyricJamSonic />} />
          <Route path="/lyricjam" element={<LyricJam />} />
          <Route path="/activation-steering" element={<ActivationSteering />} />
          <Route path="/lyotard-sublime" element={<LyotardSublime />} />
        </Routes>
      </Container>
      <Footer />
    </Router>
    </div>
  );
}

export default App;